import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: "fui-loading",
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.scss"],
    standalone: false
})
export class FUILoadingComponent implements OnInit {
    @Input() public height: number;
    @Input() public theme: string;
    @Input() public type: string;
    @Input() public width: number;

    constructor() {
    }

    ngOnInit() {
    }

}
